import React from 'react';
import PropTypes from 'prop-types';

import StatusLabel from 'components/StatusLabel';
import {
  Container,
  Row,
} from 'styled-components-reactive-grid';

function Status({ statuses }) {
  return (
    <Container>
      {
        statuses.map(status => (
          <Row key={status.label}>
            <StatusLabel
              color={status.value}
              label={status.label}
              tooltip={status.tooltip}
              showIcon
            />
          </Row>
        ))
      }
    </Container>
  );
}

Status.propTypes = {
  statuses: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    tooltip: PropTypes.string,
  })).isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./compositions/AssetsWidget/Status/index.js